module.exports = __webpack_public_path__ + "media/images/vehicles/abrollkipper-709773b4886fc8260df1c568ae43be7c.png";